import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PageWithTabs } from '../../components/shared/PageWithTabs/PageWithTabs';
import { NoReplyEmailTab } from './NoReplyEmailTab';
import { ScheduledEmailsTab } from './ScheduledEmailsTab';
import { SupplierProfileRemindersTab } from '../page-supplier-profile-reminders/SupplierProfileRemindersTab';

type Props = {
  history: RouteComponentProps['history'];
};

export const PageEmailDebug: FC<Props> = ({ history }) => {
  const tabInfo = [
    {
      name: 'No Reply',
      path: '/email-debug',
      component: NoReplyEmailTab,
    },
    {
      name: 'Scheduled Emails',
      path: '/email-debug/scheduled',
      component: ScheduledEmailsTab,
    },
    {
      name: 'Supplier Profile Reminders',
      path: '/email-debug/supplier-profile-reminders',
      component: SupplierProfileRemindersTab,
    },
  ];

  return <PageWithTabs tabInfo={tabInfo} history={history} />;
};

export default PageEmailDebug;
